// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3TUaz","header":"Messages_header__3Ca9s"};